import { hover } from '@testing-library/user-event/dist/hover';
import React from 'react';

interface CodeLineProps {
  hasComment: boolean;
  isActive: boolean;
  isHovered: boolean;
  children: React.ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: () => void;
  lineNumber: number;
  cellId: string;
}

export const getCodeLineStyle = (hasComment: boolean, isActive: boolean | null, isHovered: boolean | null) => {
  // Базовый стиль
  const baseStyle = {
    display: 'block',
    position: 'relative' as const,
    cursor: 'pointer',
    paddingLeft: '8px',
    transition: 'all 0.2s ease-in-out',
    borderRadius: '0 4px 4px 0'
  };

  // Цвет фона - меняем местами цвета
  let backgroundColor = 'transparent';
  if (isActive || hasComment) {
    backgroundColor = 'rgba(14, 27, 55, 0.1)'; // Одинаковый цвет для активного и неактивного комментария
  } else if (isHovered) {
    backgroundColor = 'rgba(0, 0, 0, 0.05)'; // Легкое выделение при наведении
  }

  // Цвет левой границы - меняем местами цвета
  let borderLeft = '4px solid transparent';
  if (isActive) {
    borderLeft = '4px solid #0E1B37'; // Тёмно-синий для активного комментария
  } else if (hasComment) {
    borderLeft = '4px solid #0E1B37'; // Тёмно-синий для неактивного комментария
  } else if (isHovered) {
    borderLeft = '4px solid rgba(14, 27, 55, 0.3)'; // Полупрозрачный тёмно-синий при наведении
  }

  return {
    ...baseStyle,
    backgroundColor,
    borderLeft,
    boxShadow: 'none',
    outline: 'none',
    outlineOffset: '0'
  };
};

export const CodeLine: React.FC<CodeLineProps> = ({
  hasComment,
  isActive,
  isHovered,
  children,
  onMouseEnter,
  onMouseLeave,
  onClick,
  lineNumber,
  cellId
}) => {
  const style = getCodeLineStyle(hasComment, isActive, isHovered);

  return (
    <div
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      data-line-number={lineNumber}
      data-cell-id={cellId}
      data-has-comments={hasComment ? 'true' : 'false'}
    >
      {children}
    </div>
  );
}; 